(() => {
  'use strict';

  const PAGE_SELECTOR = '[data-spirit-profile-page]';
  const DESCRIPTION_SELECTOR = '[data-spirit-description]';
  const SOURCE_SELECTOR = '[data-spirit-description-source]';
  const CARDS_SELECTOR = '[data-spirit-description-cards]';
  const ASIDE_SELECTOR = '[data-spirit-description-aside]';
  const STATUS_CONTAINER_SELECTOR = '[data-spirit-profile-status-container]';
  const STATUS_BAR_SELECTOR = '[data-spirit-profile-status-bar]';
  const ICON_ASSETS_SELECTOR = '[data-spirit-profile-icon-assets]';
  const PRODUCT_CONTRACT_SELECTOR = '[data-spirit-profile-product-contract]';
  const UI_CONTRACT_SELECTOR = '[data-spirit-profile-ui-contract]';
  const WHISKYBASE_MOUNT_SELECTOR = '[data-spirit-whiskybase-mount]';
  const WHISKYBASE_CONTRACT_SELECTOR = '[data-spirit-whiskybase-contract]';
  const WHISKYBASE_UI_CONTRACT_SELECTOR = '[data-spirit-whiskybase-ui-contract]';
  const WHISKYBASE_MOBILE_SLOT_SELECTOR = '[data-spirit-whiskybase-mobile-slot]';
  const BARCODE_SELECTOR = '[data-spirit-profile-barcode]';
  const BARCODE_FALLBACK_SELECTOR = '[data-spirit-profile-barcode-fallback]';
  const DESKTOP_QUERY = '(min-width: 768px)';
  const REQUIRED_SECTION_ORDER = ['about', 'tasting', 'distillery', 'facts'];
  const STATUS_ITEM_ORDER = ['volume', 'alcohol', 'chillFiltered', 'colorants'];
  const PRODUCT_FACT_CONTRACT_VERSION = 'spirit-product-facts-v1';
  const UI_CONTRACT_VERSION = 'spirit-profile-ui-v2';
  const WHISKYBASE_CONTRACT_VERSION = 'spirit-whiskybase-v1';
  const WHISKYBASE_UI_CONTRACT_VERSION = 'spirit-whiskybase-ui-v1';
  const PRODUCT_FACT_KEYS = [
    'productCategory',
    'origin',
    'volume',
    'alcohol',
    'age',
    'vintageYear',
    'bottledYear',
    'caskNumber',
    'batchNumber',
    'bottleCount',
    'manufacturer',
    'brand',
  ];
  const PRODUCT_FACT_SOURCES = {
    productCategory: 'shopify-product-type',
    origin: 'shopify-product-metafield',
    volume: 'shopify-product-metafield',
    alcohol: 'shopify-product-metafield',
    age: 'shopify-product-metafield',
    vintageYear: 'shopify-product-metafield',
    bottledYear: 'shopify-product-metafield',
    caskNumber: 'shopify-product-metafield',
    batchNumber: 'shopify-product-metafield',
    bottleCount: 'shopify-product-metafield',
    manufacturer: 'shopify-product-metafield',
    brand: 'shopify-product-metafield',
  };

  const LOCALE_CONTRACTS = {
    de: {
      headings: {
        besonderheiten: 'about',
        'tasting notes': 'tasting',
        'destillerie/abfuller': 'distillery',
        'destillerie/abfueller': 'distillery',
        'destillerie&abfuller': 'distillery',
        'destillerie&abfueller': 'distillery',
        fakten: 'facts',
      },
      tasting: {
        nase: 'nose',
        gaumen: 'palate',
        abgang: 'finish',
      },
      factLabels: {
        produktkategorie: 'productCategory',
        herkunftsland: 'origin',
        herkunft: 'origin',
        volumen: 'volume',
        alkoholgehalt: 'alcohol',
        alkohol: 'alcohol',
        alter: 'age',
        destillationsjahr: 'vintageYear',
        jahrgang: 'vintageYear',
        abfulljahr: 'bottledYear',
        abfuelljahr: 'bottledYear',
        fassnummer: 'caskNumber',
        batchnummer: 'batchNumber',
        batch: 'batchNumber',
        'lot-code': 'batchNumber',
        'lot code': 'batchNumber',
        'anzahl flaschen': 'bottleCount',
        flaschenanzahl: 'bottleCount',
        hersteller: 'manufacturer',
        produzent: 'manufacturer',
        marke: 'brand',
      },
      summaryLabels: {
        volumen: 'volume',
        alkohol: 'alcohol',
        alkoholgehalt: 'alcohol',
      },
      booleanLabels: {
        kuhlfiltration: ['chillFiltered', false],
        kuhlfiltriert: ['chillFiltered', false],
        kuhlgefiltert: ['chillFiltered', false],
        'nicht kuhlfiltriert': ['chillFiltered', true],
        'nicht kuhlgefiltert': ['chillFiltered', true],
        farbstoff: ['colorants', false],
        farbstoffe: ['colorants', false],
      },
      booleanValues: {
        ja: true,
        nein: false,
      },
      summaryPhrases: {
        kuhlfiltriert: ['chillFiltered', true],
        kuhlgefiltert: ['chillFiltered', true],
        'nicht kuhlfiltriert': ['chillFiltered', false],
        'nicht kuhlgefiltert': ['chillFiltered', false],
        'ohne farbstoff': ['colorants', false],
        'ohne farbstoffe': ['colorants', false],
        'mit farbstoff': ['colorants', true],
        'mit farbstoffen': ['colorants', true],
      },
    },
    en: {
      headings: {
        'special features': 'about',
        'tasting notes': 'tasting',
        'distillery/bottler': 'distillery',
        'distillery&bottler': 'distillery',
        facts: 'facts',
      },
      tasting: {
        nose: 'nose',
        palate: 'palate',
        finish: 'finish',
      },
      factLabels: {
        'product category': 'productCategory',
        'country of origin': 'origin',
        'origin country': 'origin',
        origin: 'origin',
        volume: 'volume',
        'alcohol content': 'alcohol',
        alcohol: 'alcohol',
        age: 'age',
        'distillation year': 'vintageYear',
        'vintage year': 'vintageYear',
        'bottling year': 'bottledYear',
        'cask number': 'caskNumber',
        'batch number': 'batchNumber',
        batch: 'batchNumber',
        'lot-code': 'batchNumber',
        'lot code': 'batchNumber',
        'bottle count': 'bottleCount',
        'number of bottles': 'bottleCount',
        manufacturer: 'manufacturer',
        producer: 'manufacturer',
        brand: 'brand',
      },
      summaryLabels: {
        volume: 'volume',
        alcohol: 'alcohol',
        'alcohol content': 'alcohol',
      },
      booleanLabels: {
        'chill filtration': ['chillFiltered', false],
        'chill filtered': ['chillFiltered', false],
        'chilled filtered': ['chillFiltered', false],
        'not chill filtered': ['chillFiltered', true],
        'not chilled filtered': ['chillFiltered', true],
        colorant: ['colorants', false],
        colorants: ['colorants', false],
        coloring: ['colorants', false],
        colouring: ['colorants', false],
      },
      booleanValues: {
        yes: true,
        no: false,
      },
      summaryPhrases: {
        'chill filtered': ['chillFiltered', true],
        'chilled filtered': ['chillFiltered', true],
        'not chill filtered': ['chillFiltered', false],
        'not chilled filtered': ['chillFiltered', false],
        'no colorant': ['colorants', false],
        'no colorants': ['colorants', false],
        'no coloring': ['colorants', false],
        'no colouring': ['colorants', false],
        'with colorant': ['colorants', true],
        'with colorants': ['colorants', true],
        'with coloring': ['colorants', true],
        'with colouring': ['colorants', true],
      },
    },
    fr: {
      headings: {
        particularites: 'about',
        'notes de degustation': 'tasting',
        'distillerie/embouteilleur': 'distillery',
        'distillerie&embouteilleur': 'distillery',
        faits: 'facts',
      },
      tasting: {
        nez: 'nose',
        bouche: 'palate',
        finale: 'finish',
      },
      factLabels: {
        'categorie de produit': 'productCategory',
        "pays d'origine": 'origin',
        'pays d origine': 'origin',
        origine: 'origin',
        volume: 'volume',
        'teneur en alcool': 'alcohol',
        "taux d'alcool": 'alcohol',
        alcool: 'alcohol',
        age: 'age',
        'annee de distillation': 'vintageYear',
        millesime: 'vintageYear',
        "annee d'embouteillage": 'bottledYear',
        'annee d embouteillage': 'bottledYear',
        'numero de fut': 'caskNumber',
        'numero de lot': 'batchNumber',
        lot: 'batchNumber',
        'nombre de bouteilles': 'bottleCount',
        fabricant: 'manufacturer',
        producteur: 'manufacturer',
        marque: 'brand',
      },
      summaryLabels: {
        volume: 'volume',
        alcool: 'alcohol',
        'teneur en alcool': 'alcohol',
        "taux d'alcool": 'alcohol',
      },
      booleanLabels: {
        'filtration a froid': ['chillFiltered', false],
        'filtre a froid': ['chillFiltered', false],
        'non filtre a froid': ['chillFiltered', true],
        colorant: ['colorants', false],
        colorants: ['colorants', false],
      },
      booleanValues: {
        oui: true,
        non: false,
      },
      summaryPhrases: {
        'filtre a froid': ['chillFiltered', true],
        'non filtre a froid': ['chillFiltered', false],
        'sans colorant': ['colorants', false],
        'sans colorants': ['colorants', false],
        'avec colorant': ['colorants', true],
        'avec colorants': ['colorants', true],
      },
    },
  };

  const ICONS = {
    nose: '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M13.1 3.5c-1.2 2.5-1.8 5.1-1.8 7.8v1.5c0 1.1-.7 2-1.7 2.4l-1.4.5c-.7.3-.6 1.3.2 1.4l2.9.4c1.1.2 2.2-.4 2.7-1.4l.6-1.2"/><path d="M14.5 18.2c1.2.8 2.8.7 3.9-.2"/></svg>',
    palate: '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M5 10.5c1.8 1.6 4.1 2.5 7 2.5s5.2-.9 7-2.5"/><path d="M7 11.9c.6 4.2 2.2 6.3 5 6.3s4.4-2.1 5-6.3"/><path d="M9.5 15.2h5"/></svg>',
    finish: '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M5 12h13"/><path d="m14 8 4 4-4 4"/><path d="M5 7.5h5M5 16.5h5"/></svg>',
    detail: '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><circle cx="12" cy="12" r="8.5"/><path d="M12 10.5v5M12 7.5h.01"/></svg>',
  };

  const normalizeText = (value) => String(value || '').replace(/\s+/g, ' ').trim();

  const normalizeKey = (value) => normalizeText(value)
    .toLocaleLowerCase()
    .replace(/ß/g, 'ss')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[–—]/g, '-')
    .replace(/\s*([/&])\s*/g, '$1')
    .replace(/\s*:\s*$/g, '')
    .trim();

  const normalizeSummaryKey = (value) => normalizeKey(value)
    .replace(/-/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();

  const productTitleTokens = (value) => normalizeKey(value)
    .replace(/[^a-z0-9]+/g, ' ')
    .split(' ')
    .filter(Boolean);

  const titleTokenMatches = (left, right) => {
    if (left === right) {
      return true;
    }
    if (left.length < 5 || right.length < 5) {
      return false;
    }
    const shorterLength = Math.min(left.length, right.length);
    let sharedPrefixLength = 0;
    while (
      sharedPrefixLength < shorterLength
      && left[sharedPrefixLength] === right[sharedPrefixLength]
    ) {
      sharedPrefixLength += 1;
    }
    return sharedPrefixLength >= Math.min(6, shorterLength);
  };

  const isLikelyLocalizedProductTitle = (headingText, productTitle) => {
    const headingKey = normalizeKey(headingText);
    const productTitleKey = normalizeKey(productTitle);
    if (headingKey === '' || productTitleKey === '') {
      return false;
    }
    if (headingKey === productTitleKey) {
      return true;
    }

    const headingTokens = productTitleTokens(headingText);
    const headingTokenSet = new Set(headingTokens);
    const titleTokens = productTitleTokens(productTitle);
    const numericTokens = [...new Set(titleTokens.filter((token) => /^\d+$/.test(token)))];
    if (numericTokens.some((token) => !headingTokenSet.has(token))) {
      return false;
    }

    const significantTitleTokens = [...new Set(titleTokens.filter((token) => (
      token.length >= 4 && /[a-z]/.test(token)
    )))];
    const significantHeadingTokens = [...new Set(headingTokens.filter((token) => (
      token.length >= 4 && /[a-z]/.test(token)
    )))];
    if (significantTitleTokens.length === 0 || significantHeadingTokens.length === 0) {
      return false;
    }

    if (!titleTokenMatches(significantTitleTokens[0], significantHeadingTokens[0])) {
      return false;
    }

    const lastHeadingToken = significantHeadingTokens[significantHeadingTokens.length - 1];
    if (!significantTitleTokens.some((token) => titleTokenMatches(token, lastHeadingToken))) {
      return false;
    }

    const unmatchedHeadingTokens = new Set(significantHeadingTokens);
    let sharedCount = 0;
    for (const titleToken of significantTitleTokens) {
      const headingToken = [...unmatchedHeadingTokens].find((candidate) => (
        titleTokenMatches(titleToken, candidate)
      ));
      if (headingToken) {
        unmatchedHeadingTokens.delete(headingToken);
        sharedCount += 1;
      }
    }
    const minimumShared = Math.min(2, significantTitleTokens.length);
    return sharedCount >= minimumShared
      && sharedCount / significantTitleTokens.length >= 0.65
      && sharedCount / significantHeadingTokens.length >= 0.5;
  };

  const includesAny = (value, candidates) => candidates.some(
    (candidate) => value.includes(candidate),
  );

  const isMediaElement = (element) => element.matches(
    'img, picture, video, audio, source, iframe, object, embed, svg, a[href]',
  ) || element.querySelector(
    'img, picture, video, audio, source, iframe, object, embed, svg, a[href]',
  );

  const isMeaningfulNode = (node) => {
    if (node.nodeType === 3) {
      return normalizeText(node.textContent) !== '';
    }

    if (node.nodeType !== 1) {
      return false;
    }

    if (node.tagName === 'BR') {
      return false;
    }

    return normalizeText(node.textContent) !== '' || Boolean(isMediaElement(node));
  };

  const appendClonedChildren = (source, target) => {
    Array.from(source.childNodes).forEach((node) => {
      target.appendChild(node.cloneNode(true));
    });
  };

  const semanticSnapshot = (element) => {
    const text = [];
    const walker = element.ownerDocument.createTreeWalker(element, 4);
    let textNode = walker.nextNode();

    while (textNode) {
      const normalized = normalizeText(textNode.textContent);
      if (normalized !== '') {
        text.push(normalized);
      }
      textNode = walker.nextNode();
    }

    const attributes = Array.from(element.querySelectorAll(
      'a[href], img, source, video, audio, iframe, object, embed',
    )).map((node) => ({
      tag: node.tagName.toLowerCase(),
      href: node.getAttribute('href') || '',
      src: node.getAttribute('src') || '',
      srcset: node.getAttribute('srcset') || '',
      alt: node.getAttribute('alt') || '',
      title: node.getAttribute('title') || '',
      target: node.getAttribute('target') || '',
      rel: node.getAttribute('rel') || '',
    }));

    const emphasis = Array.from(element.querySelectorAll('strong, b, em, i')).map((node) => ({
      tag: node.tagName.toLowerCase(),
      text: normalizeText(node.textContent),
    }));

    return JSON.stringify({ text, attributes, emphasis });
  };

  const cloneNodesIntoContainer = (nodes, documentRef) => {
    const container = documentRef.createElement('div');
    nodes.forEach((node) => container.appendChild(node.cloneNode(true)));
    return container;
  };

  const resolveLocale = (page) => {
    const value = page.dataset.spiritProfileLocale
      || page.ownerDocument.documentElement.lang
      || '';
    return String(value).toLocaleLowerCase().split('-')[0];
  };

  const resolveIconAssets = (page) => {
    const source = page.querySelector(ICON_ASSETS_SELECTOR);
    if (!source) {
      return {};
    }

    try {
      const assets = JSON.parse(source.textContent || '{}');
      return Object.fromEntries(
        Object.entries(assets).filter(([key, value]) => (
          /^[a-z0-9-]+$/.test(key)
          && typeof value === 'string'
          && value.trim() !== ''
        )),
      );
    } catch (_error) {
      return {};
    }
  };

  const resolveProductContract = (page) => {
    const source = page.querySelector(PRODUCT_CONTRACT_SELECTOR);
    if (!source) {
      return null;
    }

    try {
      const contract = JSON.parse(source.textContent || '{}');
      const contractKeys = Object.keys(contract).sort();
      const factKeys = contract.facts && typeof contract.facts === 'object'
        ? Object.keys(contract.facts).sort()
        : [];

      if (
        JSON.stringify(contractKeys) !== JSON.stringify(['baseLocale', 'facts', 'version'])
        || contract.version !== PRODUCT_FACT_CONTRACT_VERSION
        || typeof contract.baseLocale !== 'string'
        || !/^[a-z]{2}$/.test(contract.baseLocale)
        || !contract.facts
        || Array.isArray(contract.facts)
        || JSON.stringify(factKeys) !== JSON.stringify([...PRODUCT_FACT_KEYS].sort())
        || PRODUCT_FACT_KEYS.some((key) => typeof contract.facts[key] !== 'string')
      ) {
        return null;
      }

      const facts = Object.fromEntries(PRODUCT_FACT_KEYS.map((key) => [
        key,
        normalizeText(contract.facts[key]),
      ]));
      if (facts.productCategory === '') {
        return null;
      }

      return {
        version: contract.version,
        baseLocale: contract.baseLocale,
        facts,
      };
    } catch (_error) {
      return null;
    }
  };

  const factDataKey = (key) => key.replace(/[A-Z]/g, (letter) => (
    `-${letter.toLocaleLowerCase()}`
  ));

  const isPlainStructuredText = (value, maxLength) => (
    value !== ''
    && value.length <= maxLength
    && !/[\u0000-\u001f\u007f]/.test(value)
  );

  const numericValue = (value) => {
    const match = value.match(/\d+(?:[.,]\d+)?/);
    if (!match) {
      return null;
    }

    const parsed = Number(match[0].replace(',', '.'));
    return Number.isFinite(parsed) ? parsed : null;
  };

  const parseVolumeValue = (value, literLabel = '') => {
    const normalized = normalizeText(value);
    const match = normalized.match(
      /^(\d+(?:[.,]\d+)?)\s*(ml|cl|l|liter|litre|liters|litres)?$/i,
    );
    if (!match) {
      return null;
    }

    const amount = Number(match[1].replace(',', '.'));
    if (!Number.isFinite(amount) || amount <= 0 || amount > 100000) {
      return null;
    }

    const unit = (match[2] || '').toLocaleLowerCase();
    const factor = unit === 'ml' ? 1 : unit === 'cl' ? 10 : 1000;
    return {
      semanticValue: amount * factor,
      displayValue: unit === ''
        ? `${match[1]} ${literLabel}`.trim()
        : normalized,
    };
  };

  const parseAlcoholValue = (value) => {
    const normalized = normalizeText(value);
    const match = normalized.match(
      /^(\d{1,3}(?:[.,]\d{1,2})?)\s*(?:(?:%\s*(?:vol\.?|abv)?)|(?:vol\.?\s*%?)|abv)?$/i,
    );
    if (!match) {
      return null;
    }

    const amount = Number(match[1].replace(',', '.'));
    if (!Number.isFinite(amount) || amount < 0 || amount > 100) {
      return null;
    }

    return {
      semanticValue: amount,
      displayValue: `${match[1]}%`,
    };
  };

  // Sets retain each component's strength; scalar product metafields cannot
  // represent this information and must never replace it with an average.
  const parseDescriptionAlcoholValue = (value) => {
    const scalar = parseAlcoholValue(value);
    if (scalar) return scalar;
    const normalized = normalizeText(value);
    const parts = normalized.split(';');
    if (parts.length < 2 || parts.length > 30) return null;
    const components = [];
    for (const part of parts) {
      const match = part.trim().match(/^(?:(.+?)(?::\s*|\s+))?(\d{1,3}(?:[.,]\d{1,2})?(?:\s*%(?:\s*(?:vol\.?|abv))?|\s*vol\.?\s*%))$/iu);
      if (!match) return null;
      const label = normalizeText(match[1] || '');
      if (label.includes(':') || label.includes('%')) return null;
      const parsed = parseAlcoholValue(match[2]);
      if (!parsed) return null;
      components.push({ label, amount: parsed.semanticValue });
    }
    if (components.some((item) => Boolean(item.label) !== Boolean(components[0].label))) return null;
    if (components[0].label && new Set(components.map((item) => item.label.toLocaleLowerCase())).size !== components.length) return null;
    return { semanticValue: components, displayValue: normalized };
  };

  const parseBooleanValue = (value, contract) => {
    const key = normalizeSummaryKey(value);
    if (!Object.prototype.hasOwnProperty.call(contract.booleanValues, key)) {
      return null;
    }

    return contract.booleanValues[key];
  };

  const technicalReasonKey = (key) => factDataKey(key).replace(/-/g, '_');

  const equivalentTechnicalValue = (key, left, right) => {
    if (key === 'alcohol' && (Array.isArray(left) || Array.isArray(right))) {
      return Array.isArray(left) && Array.isArray(right)
        && left.length === right.length
        && left.every((item, index) => (
          item.label.toLocaleLowerCase() === right[index].label.toLocaleLowerCase()
          && Math.abs(item.amount - right[index].amount) < 0.0001
        ));
    }
    if (['volume', 'alcohol'].includes(key)) {
      return Math.abs(left - right) < 0.0001;
    }

    return left === right;
  };

  const isValidStructuredFact = (key, value) => {
    if (!isPlainStructuredText(value, ['manufacturer', 'brand'].includes(key) ? 160 : 120)) {
      return false;
    }

    if (key === 'volume') {
      return parseVolumeValue(value) !== null;
    }

    if (key === 'alcohol') {
      return parseAlcoholValue(value) !== null;
    }

    if (key === 'age') {
      const amount = numericValue(value);
      return amount !== null
        && amount >= 0
        && amount <= 200
        && /^\d{1,3}(?:\s*(?:jahr(?:e)?|years?|ans?))?$/i.test(value);
    }

    if (['vintageYear', 'bottledYear'].includes(key)) {
      return /^(?:18|19|20)\d{2}$/.test(value);
    }

    if (key === 'bottleCount') {
      return /^\d[\d\s'.,]*$/.test(value);
    }

    if (['caskNumber', 'batchNumber'].includes(key)) {
      return isPlainStructuredText(value, 80);
    }

    return true;
  };

  const isStructuredFactLocaleCompatible = (key, value, locale, baseLocale) => {
    if (key === 'origin' || key === 'age') {
      return locale === baseLocale;
    }

    if (key === 'volume' && locale !== baseLocale) {
      return /^\d+(?:[.,]\d+)?\s*(?:ml|cl|l)?$/i.test(value);
    }

    return true;
  };

  const comparableFactValue = (key, value) => {
    const normalized = normalizeText(value).toLocaleLowerCase().replace(',', '.');

    if (key === 'volume') {
      const parsed = parseVolumeValue(value);
      return parsed ? `milliliters:${parsed.semanticValue}` : normalized;
    }

    if (key === 'alcohol') {
      const parsed = parseAlcoholValue(value);
      return parsed ? `percent:${parsed.semanticValue}` : normalized;
    }

    if (['vintageYear', 'bottledYear', 'bottleCount'].includes(key)) {
      return normalized.replace(/[^\d]/g, '');
    }

    return normalizeKey(normalized);
  };

  const resolveStructuredFact = (key, productContract, locale, warnings) => {
    const value = productContract.facts[key];
    if (value === '') {
      return null;
    }

    if (!isValidStructuredFact(key, value)) {
      warnings.add(`invalid_structured_fact_${factDataKey(key).replace(/-/g, '_')}`);
      return null;
    }

    if (!isStructuredFactLocaleCompatible(
      key,
      value,
      locale,
      productContract.baseLocale,
    )) {
      return null;
    }

    return {
      key,
      source: PRODUCT_FACT_SOURCES[key],
      value,
    };
  };

  const resolveUiContract = (page) => {
    const source = page.querySelector(UI_CONTRACT_SELECTOR);
    if (!source) {
      return null;
    }

    try {
      const contract = JSON.parse(source.textContent || '{}');
      const requiredKeys = [
        'version',
        'volume',
        'alcohol',
        'chillFiltered',
        'colorants',
        'yes',
        'no',
        'liter',
        'ean',
      ];

      if (
        JSON.stringify(Object.keys(contract).sort())
          !== JSON.stringify([...requiredKeys].sort())
        || contract.version !== UI_CONTRACT_VERSION
        || requiredKeys.some((key) => (
          typeof contract[key] !== 'string'
          || normalizeText(contract[key]) === ''
        ))
      ) {
        return null;
      }

      return contract;
    } catch (_error) {
      return null;
    }
  };

  const resolveWhiskybaseContract = (mount) => {
    const source = mount.querySelector(WHISKYBASE_CONTRACT_SELECTOR);
    if (!source) {
      return { ok: false, reason: 'missing_whiskybase_contract' };
    }

    try {
      const contract = JSON.parse(source.textContent || '{}');
      const requiredKeys = [
        'version',
        'urlType',
        'url',
        'scoreType',
        'score',
        'ratingCountType',
        'ratingCount',
      ];

      if (
        !contract
        || typeof contract !== 'object'
        || Array.isArray(contract)
        || JSON.stringify(Object.keys(contract).sort())
          !== JSON.stringify([...requiredKeys].sort())
        || contract.version !== WHISKYBASE_CONTRACT_VERSION
        || requiredKeys.some((key) => typeof contract[key] !== 'string')
      ) {
        return { ok: false, reason: 'invalid_whiskybase_contract' };
      }

      return { ok: true, contract };
    } catch (_error) {
      return { ok: false, reason: 'invalid_whiskybase_contract' };
    }
  };

  const resolveWhiskybaseUiContract = (mount) => {
    const source = mount.querySelector(WHISKYBASE_UI_CONTRACT_SELECTOR);
    if (!source) {
      return { ok: false, reason: 'missing_whiskybase_ui_contract' };
    }

    try {
      const contract = JSON.parse(source.textContent || '{}');
      const requiredKeys = [
        'version',
        'heading',
        'scoreOutOf',
        'ratingSingular',
        'ratingPlural',
        'ratingPrefix',
        'source',
        'link',
        'opensNewWindow',
      ];

      if (
        !contract
        || typeof contract !== 'object'
        || Array.isArray(contract)
        || JSON.stringify(Object.keys(contract).sort())
          !== JSON.stringify([...requiredKeys].sort())
        || contract.version !== WHISKYBASE_UI_CONTRACT_VERSION
        || requiredKeys.some((key) => (
          typeof contract[key] !== 'string'
          || normalizeText(contract[key]) === ''
        ))
      ) {
        return { ok: false, reason: 'invalid_whiskybase_ui_contract' };
      }

      return {
        ok: true,
        contract: Object.fromEntries(requiredKeys.map((key) => [
          key,
          key === 'version' ? contract[key] : normalizeText(contract[key]),
        ])),
      };
    } catch (_error) {
      return { ok: false, reason: 'invalid_whiskybase_ui_contract' };
    }
  };

  const normalizeWhiskybaseUrl = (value, type) => {
    const rawUrl = String(value || '').trim();
    if (rawUrl === '') {
      return { ok: false, reason: 'missing_whiskybase_url' };
    }
    if (type !== 'url') {
      return { ok: false, reason: 'invalid_whiskybase_url' };
    }

    try {
      const parsed = new URL(rawUrl);
      const hostname = parsed.hostname.toLocaleLowerCase();
      const pathMatch = parsed.pathname.match(/^\/whiskies\/whisky\/([1-9]\d*)\/?$/);
      if (
        parsed.protocol !== 'https:'
        || !['whiskybase.com', 'www.whiskybase.com'].includes(hostname)
        || parsed.port !== ''
        || parsed.username !== ''
        || parsed.password !== ''
        || parsed.search !== ''
        || parsed.hash !== ''
        || !pathMatch
      ) {
        return { ok: false, reason: 'invalid_whiskybase_url' };
      }

      return {
        ok: true,
        value: `https://www.whiskybase.com/whiskies/whisky/${pathMatch[1]}`,
      };
    } catch (_error) {
      return { ok: false, reason: 'invalid_whiskybase_url' };
    }
  };

  const normalizeWhiskybaseScore = (value, type) => {
    const rawScore = String(value || '').trim();
    if (rawScore === '') {
      return { ok: false, reason: 'missing_whiskybase_score' };
    }
    if (
      type !== 'number_decimal'
      || !/^(?:(?:0|[1-9]\d?)(?:\.\d{1,2})?|100(?:\.0{1,2})?)$/.test(rawScore)
    ) {
      return { ok: false, reason: 'invalid_whiskybase_score' };
    }

    const score = Number(rawScore);
    if (!Number.isFinite(score) || score < 0 || score > 100) {
      return { ok: false, reason: 'invalid_whiskybase_score' };
    }

    return {
      ok: true,
      value: score,
      displayValue: String(score),
    };
  };

  const normalizeWhiskybaseRatingCount = (value, type) => {
    const rawCount = String(value || '').trim();
    if (rawCount === '') {
      return { ok: false, reason: 'missing_whiskybase_rating_count' };
    }
    if (type !== 'number_integer' || !/^[1-9]\d*$/.test(rawCount)) {
      return { ok: false, reason: 'invalid_whiskybase_rating_count' };
    }

    const count = Number(rawCount);
    if (!Number.isSafeInteger(count) || count <= 0) {
      return { ok: false, reason: 'invalid_whiskybase_rating_count' };
    }

    return { ok: true, value: count };
  };

  const normalizeWhiskybaseData = (contract) => {
    const url = normalizeWhiskybaseUrl(contract.url, contract.urlType);
    if (!url.ok) {
      return url;
    }

    const score = normalizeWhiskybaseScore(contract.score, contract.scoreType);
    if (!score.ok) {
      return score;
    }

    const ratingCount = normalizeWhiskybaseRatingCount(
      contract.ratingCount,
      contract.ratingCountType,
    );
    if (!ratingCount.ok) {
      return ratingCount;
    }

    return {
      ok: true,
      url: url.value,
      score: score.value,
      scoreDisplay: score.displayValue,
      ratingCount: ratingCount.value,
    };
  };

  const createExternalLinkIcon = (documentRef) => {
    const namespace = 'http://www.w3.org/2000/svg';
    const icon = documentRef.createElementNS(namespace, 'svg');
    icon.classList.add('spirit-whiskybase-card__link-icon');
    icon.setAttribute('viewBox', '0 0 16 16');
    icon.setAttribute('fill', 'none');
    icon.setAttribute('aria-hidden', 'true');
    icon.setAttribute('focusable', 'false');

    [
      'M9.5 2H14V6.5',
      'M7 9L14 2',
      'M12 9.5V13C12 13.55 11.55 14 11 14H3C2.45 14 2 13.55 2 13V5C2 4.45 2.45 4 3 4H6.5',
    ].forEach((pathData) => {
      const path = documentRef.createElementNS(namespace, 'path');
      path.setAttribute('d', pathData);
      path.setAttribute('stroke', 'currentColor');
      path.setAttribute('stroke-width', '1.4');
      path.setAttribute('stroke-linecap', 'round');
      path.setAttribute('stroke-linejoin', 'round');
      icon.appendChild(path);
    });

    return icon;
  };

  const SEAL_ARC_RADIUS = 36;
  const SEAL_ARC_LENGTH = 2 * Math.PI * SEAL_ARC_RADIUS;
  // Unter dieser Bogenlänge wäre das Segment kürzer als die runde Linienkappe
  // und läse sich als Punkt statt als Anteil.
  const SEAL_ARC_MIN = 4;

  /*
   * Die Punktzahl muss innerhalb des Bogens bleiben. Der Vertrag lässt 0 bis 100
   * mit bis zu zwei Nachkommastellen zu, also zwischen einem Zeichen ("9") und
   * sechs ("100.00") — bei fester Schriftgrösse stösst "83.67" bereits an den
   * Bogen. Die Grösse wird deshalb aus der Zeichenbreite abgeleitet.
   *
   * Innerer freier Durchmesser: 2 × (36 − 2.5 Linienbreite) = 67 Einheiten,
   * davon 58 als Textbudget, der Rest bleibt Luft.
   */
  const SEAL_VALUE_BUDGET = 58;
  const SEAL_VALUE_MAX_SIZE = 27;
  const SEAL_DIGIT_EM = 0.58;
  const SEAL_SEPARATOR_EM = 0.28;

  const sealValueFontSize = (text) => {
    let width = 0;
    for (const character of String(text)) {
      width += character === '.' || character === ',' ? SEAL_SEPARATOR_EM : SEAL_DIGIT_EM;
    }
    if (width <= 0) {
      return SEAL_VALUE_MAX_SIZE;
    }
    return Math.min(SEAL_VALUE_MAX_SIZE, SEAL_VALUE_BUDGET / width);
  };

  /*
   * Fassdeckel-Marke: der Ring ist die Schablone, der Bogen die Punktzahl.
   * "Whiskybase" steht als Markenname fest und wird nicht übersetzt; die Skala
   * darunter kommt aus dem UI-Vertrag.
   */
  const createWhiskybaseSeal = (documentRef, data, ui, sealId) => {
    const ns = 'http://www.w3.org/2000/svg';
    const svg = documentRef.createElementNS(ns, 'svg');
    svg.setAttribute('class', 'spirit-whiskybase-card__seal');
    svg.setAttribute('viewBox', '0 0 120 120');
    svg.setAttribute('aria-hidden', 'true');
    svg.setAttribute('focusable', 'false');

    const defs = documentRef.createElementNS(ns, 'defs');
    const capPath = documentRef.createElementNS(ns, 'path');
    capPath.setAttribute('id', sealId);
    capPath.setAttribute('d', 'M 18 60 A 42 42 0 0 1 102 60');
    defs.appendChild(capPath);

    const circle = (cls, radius) => {
      const node = documentRef.createElementNS(ns, 'circle');
      node.setAttribute('class', cls);
      node.setAttribute('cx', '60');
      node.setAttribute('cy', '60');
      node.setAttribute('r', String(radius));
      return node;
    };

    const ring = circle('spirit-whiskybase-card__seal-ring', 56);
    const track = circle('spirit-whiskybase-card__seal-track', SEAL_ARC_RADIUS);

    const filled = Math.max(
      SEAL_ARC_MIN,
      (SEAL_ARC_LENGTH * Math.min(Math.max(data.score, 0), 100)) / 100,
    );
    const arc = circle('spirit-whiskybase-card__seal-arc', SEAL_ARC_RADIUS);
    arc.setAttribute(
      'stroke-dasharray',
      `${filled.toFixed(2)} ${SEAL_ARC_LENGTH.toFixed(2)}`,
    );
    arc.setAttribute('transform', 'rotate(-90 60 60)');

    const cap = documentRef.createElementNS(ns, 'text');
    cap.setAttribute('class', 'spirit-whiskybase-card__seal-cap');
    cap.setAttribute('text-anchor', 'middle');
    const capTextPath = documentRef.createElementNS(ns, 'textPath');
    capTextPath.setAttributeNS('http://www.w3.org/1999/xlink', 'href', `#${sealId}`);
    capTextPath.setAttribute('href', `#${sealId}`);
    capTextPath.setAttribute('startOffset', '50%');
    capTextPath.textContent = 'Whiskybase';
    cap.appendChild(capTextPath);

    const value = documentRef.createElementNS(ns, 'text');
    value.setAttribute('class', 'spirit-whiskybase-card__seal-value');
    value.setAttribute('x', '60');
    value.setAttribute('y', '63');
    value.setAttribute('text-anchor', 'middle');
    value.setAttribute('font-size', sealValueFontSize(data.scoreDisplay).toFixed(2));
    value.textContent = data.scoreDisplay;

    const scale = documentRef.createElementNS(ns, 'text');
    scale.setAttribute('class', 'spirit-whiskybase-card__seal-scale');
    scale.setAttribute('x', '60');
    scale.setAttribute('y', '76');
    scale.setAttribute('text-anchor', 'middle');
    scale.textContent = ui.scoreOutOf;

    svg.append(defs, ring, track, arc, cap, value, scale);
    return svg;
  };

  const buildWhiskybaseCard = (mount, data, ui) => {
    const documentRef = mount.ownerDocument;
    const card = documentRef.createElement('aside');
    card.className = 'spirit-whiskybase-card';
    card.dataset.spiritWhiskybaseCard = '';

    const page = mount.closest(PAGE_SELECTOR);
    const mountIndex = page
      ? Array.from(page.querySelectorAll(WHISKYBASE_MOUNT_SELECTOR)).indexOf(mount)
      : 0;
    const baseId = mount.id || `spirit-whiskybase-${mountIndex + 1}`;
    const headingId = `${baseId}-heading`;
    card.setAttribute('aria-labelledby', headingId);

    const heading = documentRef.createElement('h2');
    heading.id = headingId;
    heading.className = 'spirit-whiskybase-card__heading';
    heading.textContent = ui.heading;

    const rating = documentRef.createElement('div');
    rating.className = 'spirit-whiskybase-card__rating';

    const seal = createWhiskybaseSeal(documentRef, data, ui, `${baseId}-seal-cap`);

    const body = documentRef.createElement('div');
    body.className = 'spirit-whiskybase-card__body';

    const stars = documentRef.createElement('span');
    stars.className = 'spirit-whiskybase-card__stars';
    stars.setAttribute('aria-hidden', 'true');
    const activeStars = documentRef.createElement('span');
    activeStars.className = 'spirit-whiskybase-card__stars-active';
    activeStars.style.width = `${data.score}%`;
    stars.appendChild(activeStars);

    const meta = documentRef.createElement('div');
    meta.className = 'spirit-whiskybase-card__meta';

    const count = documentRef.createElement('p');
    count.className = 'spirit-whiskybase-card__count';
    // "Community-Durchschnitt / aus 12 Bewertungen" — die Präposition steckt in
    // einem eigenen Schlüssel, weil sie sich nicht sprachneutral voranstellen
    // lässt.
    count.textContent = `${ui.ratingPrefix} ${data.ratingCount} ${
      data.ratingCount === 1 ? ui.ratingSingular : ui.ratingPlural
    }`;

    const source = documentRef.createElement('p');
    source.className = 'spirit-whiskybase-card__source';
    source.textContent = ui.source;
    // Erst die Quelle, dann die Menge: "Community-Durchschnitt" /
    // "aus 12 Bewertungen" ergibt zusammen einen Satz.
    meta.append(source, count);

    const link = documentRef.createElement('a');
    link.className = 'spirit-whiskybase-card__link';
    link.href = data.url;
    link.target = '_blank';
    link.rel = 'noopener noreferrer nofollow external';

    const linkText = documentRef.createElement('span');
    linkText.textContent = ui.link;
    const newWindowText = documentRef.createElement('span');
    newWindowText.className = 'visually-hidden';
    newWindowText.textContent = ` ${ui.opensNewWindow}`;
    link.append(linkText, newWindowText, createExternalLinkIcon(documentRef));

    // Die Marke ist aria-hidden, deshalb trägt dieser Text die Punktzahl. Der
    // Bereich ist bereits über die Überschrift benannt — den Namen hier zu
    // wiederholen liesse Screenreader ihn zweimal ansagen.
    const accessibleScore = documentRef.createElement('span');
    accessibleScore.className = 'visually-hidden';
    accessibleScore.dataset.spiritWhiskybaseScore = '';
    accessibleScore.textContent = `${data.scoreDisplay} ${ui.scoreOutOf}`;

    body.append(stars, meta, link);
    rating.append(seal, body, accessibleScore);

    card.append(heading, rating);
    return card;
  };

  const setWhiskybaseUnavailable = (mount, reason) => {
    mount.querySelector('[data-spirit-whiskybase-card]')?.remove();
    mount.dataset.spiritWhiskybaseState = 'unavailable';
    mount.dataset.spiritWhiskybaseReason = reason;
  };

  const enhanceWhiskybase = (page) => {
    const mount = page.querySelector(WHISKYBASE_MOUNT_SELECTOR);
    if (!mount || mount.dataset.spiritWhiskybaseState === 'enhanced') {
      return;
    }

    const resolvedContract = resolveWhiskybaseContract(mount);
    if (!resolvedContract.ok) {
      setWhiskybaseUnavailable(mount, resolvedContract.reason);
      return;
    }

    const resolvedUi = resolveWhiskybaseUiContract(mount);
    if (!resolvedUi.ok) {
      setWhiskybaseUnavailable(mount, resolvedUi.reason);
      return;
    }

    const data = normalizeWhiskybaseData(resolvedContract.contract);
    if (!data.ok) {
      setWhiskybaseUnavailable(mount, data.reason);
      return;
    }

    mount.appendChild(buildWhiskybaseCard(mount, data, resolvedUi.contract));
    mount.dataset.spiritWhiskybaseState = 'enhanced';
    delete mount.dataset.spiritWhiskybaseReason;
  };

  const resolveFactIconType = (label) => {
    const key = normalizeKey(label);

    if (includesAny(key, ['farbstoff', 'colorant', 'colouring', 'coloring'])) {
      return 'natural-color';
    }
    if (includesAny(key, [
      'kuhl',
      'chill',
      'filtre a froid',
      'filtration a froid',
      'filtrage a froid',
    ])) {
      return 'non-chill-filtered';
    }
    if (includesAny(key, ['bio', 'organic', 'biologique'])) {
      return 'organic';
    }
    if (includesAny(key, ['destillerie', 'distillery', 'distillerie', 'hersteller', 'manufacturer', 'fabricant'])) {
      return 'distillery';
    }
    if (includesAny(key, ['abfuller', 'bottler', 'embouteilleur'])) {
      return 'bottler';
    }
    if (includesAny(key, ['abfulljahr', 'bottling year', "annee d'embouteillage", 'annee d embouteillage', 'destillationsjahr', 'distillation year', 'annee de distillation'])) {
      return 'bottling-year';
    }
    if (includesAny(key, ['fassnummer', 'cask number', 'batch', 'lot-code', 'lot code', 'code de lot'])) {
      return 'batch';
    }
    if (key.includes('region')) {
      return 'region';
    }
    if (includesAny(key, ['herkunft', 'country of origin', 'origin country', "pays d'origine", 'pays d origine', 'land'])) {
      return 'origin';
    }
    if (includesAny(key, ['alkohol', 'alcohol', 'alcool', 'fassstarke', 'cask strength', 'force de fut'])) {
      return 'strength';
    }
    if (includesAny(key, ['volumen', 'volume'])) {
      return 'volume';
    }
    if (includesAny(key, ['alter', 'age'])) {
      return 'age';
    }
    if (includesAny(key, ['fass', 'cask', 'fut'])) {
      return 'cask';
    }
    if (includesAny(key, ['verpackung', 'packaging', 'emballage'])) {
      return 'packaging';
    }
    if (includesAny(key, ['rauch', 'smoke', 'fumee'])) {
      return 'smoke';
    }
    if (key.includes('allergen')) {
      return 'allergens';
    }
    if (includesAny(key, ['ean', 'barcode', 'code-barres', 'code barres'])) {
      return 'ean';
    }
    if (includesAny(key, ['aroma', 'arome'])) {
      return 'aroma';
    }
    if (includesAny(key, ['produkttyp', 'produkt typ', 'product type', 'type de produit'])) {
      return 'product-type';
    }
    if (includesAny(key, ['produktkategorie', 'produkt kategorie', 'product category', 'categorie de produit', 'profil', 'profile'])) {
      return 'profile';
    }
    return 'detail';
  };

  const headingCandidate = (element, contract) => {
    const tagName = element.tagName;
    const rawText = normalizeText(element.textContent);
    const key = normalizeKey(rawText);
    const mappedType = contract.headings[key] || null;

    if (mappedType) {
      return {
        type: mappedType,
        text: rawText.replace(/\s*:\s*$/, ''),
        unknown: false,
      };
    }

    const firstMeaningfulChild = Array.from(element.childNodes).find(isMeaningfulNode);
    const inlineLabel = ['P', 'DIV'].includes(tagName)
      && firstMeaningfulChild?.nodeType === 1
      && firstMeaningfulChild.matches('strong, b')
      && normalizeText(firstMeaningfulChild.textContent).endsWith(':')
      ? firstMeaningfulChild
      : null;
    if (inlineLabel) {
      const labelText = normalizeText(inlineLabel.textContent).replace(/\s*:\s*$/, '');
      const inlineType = contract.headings[normalizeKey(labelText)] || null;
      const content = valueWithoutLabel(element, inlineLabel);

      return {
        type: inlineType,
        text: labelText,
        unknown: inlineType === null,
        content: isMeaningfulNode(content) ? content : null,
      };
    }

    const isNativeHeading = /^H[1-6]$/.test(tagName);
    const strongElements = Array.from(element.children).filter((child) => (
      child.matches('strong, b')
    ));
    const onlyStrongContent = ['P', 'DIV'].includes(tagName)
      && strongElements.length === 1
      && Array.from(element.children).every((child) => child.matches('strong, b, br'))
      && rawText.endsWith(':');

    if (isNativeHeading || onlyStrongContent) {
      return {
        type: null,
        text: rawText.replace(/\s*:\s*$/, ''),
        unknown: true,
      };
    }

    return null;
  };

  const firstMeaningfulTextNode = (element) => {
    const walker = element.ownerDocument.createTreeWalker(element, 4);
    let node = walker.nextNode();

    while (node) {
      if (normalizeText(node.textContent) !== '') {
        return node;
      }
      node = walker.nextNode();
    }

    return null;
  };

  const valueWithoutLabel = (item, labelElement) => {
    const value = item.cloneNode(true);
    const clonedLabels = Array.from(value.querySelectorAll('strong, b'));
    const labelIndex = Array.from(item.querySelectorAll('strong, b')).indexOf(labelElement);
    const clonedLabel = clonedLabels[labelIndex];

    if (clonedLabel) {
      clonedLabel.remove();
    }

    const firstText = firstMeaningfulTextNode(value);
    if (firstText) {
      firstText.textContent = firstText.textContent.replace(/^\s*:\s*/, '');
    }

    return value;
  };

  const analyzeTasting = (group, contract) => {
    if (group.nodes.length !== 1 || !['UL', 'OL'].includes(group.nodes[0].tagName)) {
      return { ok: false, reason: 'invalid_tasting_structure' };
    }

    const list = group.nodes[0];
    const items = Array.from(list.children);
    if (items.length !== 3 || items.some((item) => item.tagName !== 'LI')) {
      return { ok: false, reason: 'invalid_tasting_items' };
    }

    const rows = [];
    const seen = new Set();

    for (const item of items) {
      const labelElement = item.querySelector('strong, b');
      if (!labelElement) {
        return { ok: false, reason: 'missing_tasting_label' };
      }

      const labelText = normalizeText(labelElement.textContent).replace(/\s*:\s*$/, '');
      const key = contract.tasting[normalizeKey(labelText)] || null;
      if (!key || seen.has(key)) {
        return { ok: false, reason: key ? 'duplicate_tasting_label' : 'unknown_tasting_label' };
      }

      const value = valueWithoutLabel(item, labelElement);
      if (!isMeaningfulNode(value)) {
        return { ok: false, reason: 'empty_tasting_value' };
      }

      seen.add(key);
      rows.push({
        key,
        label: labelText,
        value,
        snapshot: semanticSnapshot(value),
      });
    }

    if (seen.size !== 3 || !['nose', 'palate', 'finish'].every((key) => seen.has(key))) {
      return { ok: false, reason: 'incomplete_tasting_labels' };
    }

    return { ok: true, rows };
  };

  const analyzeFacts = (group, contract, productContract, locale, ui) => {
    if (group.nodes.length !== 1 || group.nodes[0].tagName !== 'TABLE') {
      return { ok: false, reason: 'invalid_facts_structure' };
    }

    const table = group.nodes[0];
    if (table.querySelector('table') || table.querySelector('caption')) {
      return { ok: false, reason: 'unsupported_facts_table' };
    }

    const tableRows = Array.from(table.querySelectorAll('tr'));
    if (tableRows.length === 0) {
      return { ok: false, reason: 'empty_facts_table' };
    }

    const rows = [];
    for (const row of tableRows) {
      const cells = Array.from(row.children).filter((cell) => ['TH', 'TD'].includes(cell.tagName));
      if (cells.length !== 2 || cells.length !== row.children.length) {
        return { ok: false, reason: 'invalid_facts_row' };
      }
      if (cells.some((cell) => (
        Number(cell.getAttribute('colspan') || 1) !== 1
        || Number(cell.getAttribute('rowspan') || 1) !== 1
      ))) {
        return { ok: false, reason: 'spanning_facts_cell' };
      }
      if (!cells.every(isMeaningfulNode)) {
        return { ok: false, reason: 'empty_facts_cell' };
      }

      const labelKey = normalizeSummaryKey(cells[0].textContent);
      const booleanDefinition = contract.booleanLabels[labelKey] || null;
      const mappedFactKey = contract.factLabels[normalizeKey(cells[0].textContent)] || null;
      const factKey = booleanDefinition ? booleanDefinition[0] : mappedFactKey;
      if (factKey === 'productCategory') {
        if (cells[1].children.length !== 0 || isMediaElement(cells[1])) {
          return { ok: false, reason: 'unsupported_product_category_value' };
        }
      }

      let normalizedTechnicalFact = null;
      if (booleanDefinition || ['volume', 'alcohol'].includes(factKey)) {
        if (
          cells[0].children.length !== 0
          || cells[1].children.length !== 0
          || isMediaElement(cells[0])
          || isMediaElement(cells[1])
        ) {
          return { ok: false, reason: 'unsafe_technical_fact_markup' };
        }

        if (booleanDefinition) {
          const parsedValue = parseBooleanValue(cells[1].textContent, contract);
          if (parsedValue === null) {
            return { ok: false, reason: 'invalid_boolean_fact' };
          }

          const semanticValue = booleanDefinition[1] ? !parsedValue : parsedValue;
          normalizedTechnicalFact = {
            key: factKey,
            semanticValue,
            label: ui[factKey],
            value: semanticValue ? ui.yes : ui.no,
          };
        } else {
          const parsedValue = factKey === 'volume'
            ? parseVolumeValue(cells[1].textContent, ui.liter)
            : parseDescriptionAlcoholValue(cells[1].textContent);
          if (!parsedValue) {
            return {
              ok: false,
              reason: `invalid_${technicalReasonKey(factKey)}_fact`,
            };
          }

          normalizedTechnicalFact = {
            key: factKey,
            semanticValue: parsedValue.semanticValue,
            label: ui[factKey],
            value: parsedValue.displayValue,
          };
        }
      }

      rows.push({
        label: cells[0],
        value: cells[1],
        labelSnapshot: semanticSnapshot(cells[0]),
        valueSnapshot: semanticSnapshot(cells[1]),
        factKey,
        valueSource: 'description',
        structuredValue: '',
        normalizedTechnicalFact,
      });
    }

    const keyCounts = rows.reduce((counts, row) => {
      if (row.factKey) {
        counts.set(row.factKey, (counts.get(row.factKey) || 0) + 1);
      }
      return counts;
    }, new Map());
    const productCategoryCount = keyCounts.get('productCategory') || 0;

    if (productCategoryCount === 0) {
      return { ok: false, reason: 'missing_product_category_fact' };
    }
    if (productCategoryCount > 1) {
      return { ok: false, reason: 'duplicate_product_category_fact' };
    }
    for (const key of STATUS_ITEM_ORDER) {
      if ((keyCounts.get(key) || 0) > 1) {
        return {
          ok: false,
          reason: `duplicate_technical_fact_${technicalReasonKey(key)}`,
        };
      }
    }

    const warnings = new Set();
    for (const row of rows) {
      if (!row.factKey) {
        continue;
      }

      if (row.normalizedTechnicalFact) {
        if (!['volume', 'alcohol'].includes(row.factKey)) {
          continue;
        }

        if (row.factKey === 'alcohol' && Array.isArray(row.normalizedTechnicalFact.semanticValue)) {
          continue;
        }

        const structured = resolveStructuredFact(
          row.factKey,
          productContract,
          locale,
          warnings,
        );
        if (!structured) {
          continue;
        }

        const parsedStructured = row.factKey === 'volume'
          ? parseVolumeValue(structured.value, ui.liter)
          : parseAlcoholValue(structured.value);
        if (!parsedStructured) {
          return {
            ok: false,
            reason: `invalid_${technicalReasonKey(row.factKey)}_fact`,
          };
        }

        row.valueSource = structured.source;
        row.structuredValue = structured.value;
        row.normalizedTechnicalFact = {
          ...row.normalizedTechnicalFact,
          semanticValue: parsedStructured.semanticValue,
          value: parsedStructured.displayValue,
        };
        if (
          comparableFactValue(row.factKey, row.value.textContent)
            !== comparableFactValue(row.factKey, structured.value)
        ) {
          warnings.add(
            `structured_fact_conflict_${technicalReasonKey(row.factKey)}`,
          );
        }
        continue;
      }

      if (row.factKey !== 'productCategory' && keyCounts.get(row.factKey) > 1) {
        warnings.add(
          `duplicate_structured_fact_${factDataKey(row.factKey).replace(/-/g, '_')}`,
        );
        continue;
      }

      if (
        row.factKey !== 'productCategory'
        && (row.value.children.length !== 0 || isMediaElement(row.value))
      ) {
        warnings.add(
          `structured_fact_markup_preserved_${factDataKey(row.factKey).replace(/-/g, '_')}`,
        );
        continue;
      }

      const structured = resolveStructuredFact(
        row.factKey,
        productContract,
        locale,
        warnings,
      );
      if (!structured) {
        if (row.factKey === 'productCategory') {
          return { ok: false, reason: 'invalid_product_category_contract' };
        }
        continue;
      }

      row.valueSource = structured.source;
      row.structuredValue = structured.value;
      if (
        row.factKey !== 'productCategory'
        && comparableFactValue(row.factKey, row.value.textContent)
          !== comparableFactValue(row.factKey, structured.value)
      ) {
        warnings.add(
          `structured_fact_conflict_${factDataKey(row.factKey).replace(/-/g, '_')}`,
        );
      }
    }

    return { ok: true, rows, warnings: Array.from(warnings).sort() };
  };

  const parseStatusSummaryPart = (part, contract, ui) => {
    const rawPart = normalizeText(part);
    const separatorIndex = rawPart.indexOf(':');

    if (separatorIndex > 0) {
      const rawLabel = rawPart.slice(0, separatorIndex);
      const rawValue = normalizeText(rawPart.slice(separatorIndex + 1));
      const labelKey = normalizeSummaryKey(rawLabel);
      const booleanDefinition = contract.booleanLabels[labelKey] || null;

      if (rawValue === '') {
        return { ok: false, reason: 'empty_status_value' };
      }

      if (booleanDefinition) {
        const parsedValue = parseBooleanValue(rawValue, contract);
        if (parsedValue === null) {
          return { ok: false, reason: 'invalid_boolean_status' };
        }

        const semanticValue = booleanDefinition[1] ? !parsedValue : parsedValue;
        return {
          ok: true,
          item: {
            key: booleanDefinition[0],
            semanticValue,
            value: semanticValue ? ui.yes : ui.no,
          },
        };
      }

      const key = contract.summaryLabels[labelKey] || null;
      if (!['volume', 'alcohol'].includes(key)) {
        return { ok: false, reason: 'unknown_status_fact' };
      }

      const parsedValue = key === 'volume'
        ? parseVolumeValue(rawValue, ui.liter)
        : parseDescriptionAlcoholValue(rawValue);
      if (!parsedValue) {
        return {
          ok: false,
          reason: `invalid_status_${technicalReasonKey(key)}`,
        };
      }

      return {
        ok: true,
        item: {
          key,
          semanticValue: parsedValue.semanticValue,
          value: parsedValue.displayValue,
        },
      };
    }

    const phrase = contract.summaryPhrases[normalizeSummaryKey(rawPart)] || null;
    if (!phrase) {
      return { ok: false, reason: 'unknown_status_fact' };
    }

    const [key, semanticValue] = phrase;
    return {
      ok: true,
      item: {
        key,
        semanticValue,
        value: semanticValue ? ui.yes : ui.no,
      },
    };
  };

  const analyzeStatusSummary = (intro, contract, ui) => {
    const pipeCandidates = intro.filter((node) => (
      ['P', 'DIV'].includes(node.tagName)
      && normalizeText(node.textContent).includes('|')
    ));
    const malformedCandidate = pipeCandidates.find((node) => {
      const partCount = normalizeText(node.textContent).split('|').length;
      return partCount > STATUS_ITEM_ORDER.length;
    });
    if (malformedCandidate) {
      return { ok: false, reason: 'invalid_status_summary' };
    }

    const candidates = pipeCandidates.filter((node) => (
      normalizeText(node.textContent).split('|').length >= 3
    ));

    if (candidates.length === 0) {
      return { ok: true, summary: null };
    }
    if (candidates.length > 1) {
      return { ok: false, reason: 'ambiguous_status_summary' };
    }

    const node = candidates[0];
    if (node.children.length !== 0 || isMediaElement(node)) {
      return { ok: false, reason: 'unsafe_status_markup' };
    }

    const parts = normalizeText(node.textContent).split('|');
    const parsedItems = parts.map((part) => parseStatusSummaryPart(part, contract, ui));
    const invalidItem = parsedItems.find((item) => !item.ok);
    if (invalidItem) {
      return invalidItem;
    }

    const byKey = new Map();
    for (const { item } of parsedItems) {
      if (byKey.has(item.key)) {
        return { ok: false, reason: 'duplicate_status_fact' };
      }
      byKey.set(item.key, item);
    }

    if (!['volume', 'alcohol'].every((key) => byKey.has(key))) {
      return { ok: false, reason: 'incomplete_status_summary' };
    }

    return {
      ok: true,
      summary: {
        node,
        items: STATUS_ITEM_ORDER.filter((key) => byKey.has(key)).map((key) => byKey.get(key)),
      },
    };
  };

  const reconcileStatusFacts = (statusSummary, factRows) => {
    if (!statusSummary) {
      return { ok: true };
    }

    const factsByKey = new Map(
      factRows
        .filter((row) => row.normalizedTechnicalFact)
        .map((row) => [row.normalizedTechnicalFact.key, row.normalizedTechnicalFact]),
    );

    for (const statusItem of statusSummary.items) {
      const fact = factsByKey.get(statusItem.key);
      if (
        fact
        && !equivalentTechnicalValue(
          statusItem.key,
          statusItem.semanticValue,
          fact.semanticValue,
        )
      ) {
        return {
          ok: false,
          reason: `status_fact_conflict_${technicalReasonKey(statusItem.key)}`,
        };
      }
    }

    return { ok: true };
  };

  const analyzeDescription = (source, locale, ui, productContract) => {
    const contract = LOCALE_CONTRACTS[locale];
    if (!contract) {
      return { ok: false, reason: 'unsupported_locale' };
    }

    const nodes = [];
    for (const node of Array.from(source.childNodes)) {
      if (!isMeaningfulNode(node)) {
        continue;
      }
      if (node.nodeType !== 1) {
        return { ok: false, reason: 'unsupported_top_level_text' };
      }
      nodes.push(node);
    }

    if (nodes.length === 0) {
      return { ok: false, reason: 'empty_description' };
    }

    const groups = Object.fromEntries(REQUIRED_SECTION_ORDER.map((type) => [
      type,
      { type, heading: null, nodes: [] },
    ]));
    const intro = [];
    const seen = new Set();
    let currentType = null;
    let nextSectionIndex = 0;
    let duplicateTitleSeen = false;

    for (const node of nodes) {
      const heading = headingCandidate(node, contract);
      if (heading) {
        if (heading.unknown) {
          const productTitle = source.dataset.productTitle || '';
          const isDuplicateProductTitle = currentType === null
            && !duplicateTitleSeen
            && source.dataset.hideDuplicateTitleHeading === 'true'
            && /^H[1-6]$/.test(node.tagName)
            && isLikelyLocalizedProductTitle(
              heading.text,
              productTitle,
            );
          if (isDuplicateProductTitle) {
            duplicateTitleSeen = true;
            if (normalizeKey(heading.text) !== normalizeKey(productTitle)) {
              intro.push(node);
            }
            continue;
          }
          return { ok: false, reason: 'unknown_heading' };
        }

        const expectedType = REQUIRED_SECTION_ORDER[nextSectionIndex];
        if (heading.type !== expectedType) {
          return {
            ok: false,
            reason: seen.has(heading.type) ? 'duplicate_section' : 'invalid_section_order',
          };
        }

        currentType = heading.type;
        groups[currentType].heading = heading;
        if (heading.content) {
          groups[currentType].nodes.push(heading.content);
        }
        seen.add(currentType);
        nextSectionIndex += 1;
        continue;
      }

      if (node.matches('h1, h2, h3, h4, h5, h6') || node.querySelector('h1, h2, h3, h4, h5, h6')) {
        return { ok: false, reason: 'unknown_heading' };
      }

      if (currentType === null) {
        intro.push(node);
      } else {
        groups[currentType].nodes.push(node);
      }
    }

    if (seen.size !== REQUIRED_SECTION_ORDER.length) {
      return { ok: false, reason: 'missing_section' };
    }
    if (intro.length === 0) {
      return { ok: false, reason: 'missing_intro' };
    }
    if (REQUIRED_SECTION_ORDER.some((type) => groups[type].nodes.length === 0)) {
      return { ok: false, reason: 'empty_section' };
    }

    const tasting = analyzeTasting(groups.tasting, contract);
    if (!tasting.ok) {
      return tasting;
    }

    const facts = analyzeFacts(groups.facts, contract, productContract, locale, ui);
    if (!facts.ok) {
      return facts;
    }

    const status = analyzeStatusSummary(intro, contract, ui);
    if (!status.ok) {
      return status;
    }

    const reconciliation = reconcileStatusFacts(status.summary, facts.rows);
    if (!reconciliation.ok) {
      return reconciliation;
    }

    return {
      ok: true,
      intro,
      groups,
      tastingRows: tasting.rows,
      factRows: facts.rows,
      warnings: facts.warnings,
      statusSummary: status.summary,
    };
  };

  const createIcon = (documentRef, type, iconAssets) => {
    const icon = documentRef.createElement('span');
    icon.className = `spirit-description-icon spirit-description-icon--${type}`;
    icon.setAttribute('aria-hidden', 'true');

    const source = iconAssets[type] || iconAssets.detail;
    if (source) {
      const image = documentRef.createElement('img');
      image.className = `product-spirit-icon product-spirit-icon--${type}`;
      image.src = source;
      image.width = 96;
      image.height = 96;
      image.alt = '';
      image.setAttribute('loading', 'eager');
      image.decoding = 'async';
      icon.appendChild(image);
    } else {
      icon.innerHTML = ICONS[type] || ICONS.detail;
    }

    return icon;
  };

  const readBarcodeValue = (page) => {
    const source = page.querySelector(BARCODE_SELECTOR);
    if (!source) {
      return '';
    }

    const explicitValue = normalizeText(source.dataset.spiritProfileBarcodeValue);
    if (explicitValue !== '') {
      return explicitValue;
    }

    return normalizeText(source.textContent)
      .replace(/^(?:EAN|Barcode|Code-barres|Code barres)\s*:\s*/i, '')
      .trim();
  };

  const analyzeBarcode = (page, factRows) => {
    const barcode = readBarcodeValue(page);
    const descriptionRows = factRows.filter((row) => (
      resolveFactIconType(row.label.textContent) === 'ean'
    ));

    if (descriptionRows.length > 1) {
      return { ok: false, reason: 'duplicate_ean_fact' };
    }

    if (descriptionRows.length === 1) {
      const descriptionValue = normalizeText(descriptionRows[0].value.textContent);
      if (barcode !== '' && descriptionValue !== barcode) {
        return { ok: false, reason: 'barcode_conflict' };
      }

      return {
        ok: true,
        mode: 'source',
        value: descriptionValue,
        hideFallback: barcode !== '',
      };
    }

    return {
      ok: true,
      mode: 'supplemental',
      value: barcode,
      hideFallback: barcode !== '',
    };
  };

  const createCardShell = (documentRef, type, title) => {
    const card = documentRef.createElement('section');
    card.className = `spirit-description-card spirit-description-card--${type}`;
    card.dataset.spiritDescriptionCard = type;

    const heading = documentRef.createElement('h2');
    heading.className = 'spirit-description-card__title';
    heading.textContent = title;

    const body = documentRef.createElement('div');
    body.className = 'spirit-description-card__body rte';

    card.append(heading, body);
    return { card, body };
  };

  const buildNarrativeCard = (documentRef, type, title, nodes) => {
    const { card, body } = createCardShell(documentRef, type, title);
    nodes.forEach((node) => body.appendChild(node.cloneNode(true)));

    const sourceContainer = cloneNodesIntoContainer(nodes, documentRef);
    if (semanticSnapshot(sourceContainer) !== semanticSnapshot(body)) {
      return null;
    }

    return card;
  };

  const buildTastingCard = (documentRef, title, rows, iconAssets) => {
    const { card, body } = createCardShell(documentRef, 'tasting', title);
    const list = documentRef.createElement('div');
    list.className = 'spirit-tasting-list';

    for (const row of rows) {
      const item = documentRef.createElement('div');
      item.className = `spirit-tasting-list__item spirit-tasting-list__item--${row.key}`;
      const content = documentRef.createElement('div');
      content.className = 'spirit-tasting-list__content';
      const label = documentRef.createElement('strong');
      label.className = 'spirit-tasting-list__label';
      label.textContent = `${row.label}:`;
      const value = documentRef.createElement('span');
      value.className = 'spirit-tasting-list__value';
      appendClonedChildren(row.value, value);

      if (semanticSnapshot(value) !== row.snapshot) {
        return null;
      }

      content.append(label, value);
      item.append(createIcon(documentRef, row.key, iconAssets), content);
      list.appendChild(item);
    }

    body.appendChild(list);
    return card;
  };

  const createSupplementalEanItem = (documentRef, labelText, valueText, iconAssets) => {
    const item = documentRef.createElement('div');
    item.className = 'spirit-fact-list__item';
    item.dataset.spiritProfileEan = 'supplemental';

    const label = documentRef.createElement('dt');
    label.className = 'spirit-fact-list__label';
    label.textContent = labelText;

    const value = documentRef.createElement('dd');
    value.className = 'spirit-fact-list__value';
    value.textContent = valueText;

    item.append(
      createIcon(documentRef, 'ean', iconAssets),
      label,
      value,
    );
    return item;
  };

  const buildFactsCard = (documentRef, title, rows, iconAssets, barcode, ui) => {
    const { card, body } = createCardShell(documentRef, 'facts', title);
    const list = documentRef.createElement('dl');
    list.className = 'spirit-fact-list';

    for (const row of rows) {
      const item = documentRef.createElement('div');
      item.className = 'spirit-fact-list__item';
      const label = documentRef.createElement('dt');
      label.className = 'spirit-fact-list__label';
      const value = documentRef.createElement('dd');
      value.className = 'spirit-fact-list__value';

      if (row.normalizedTechnicalFact) {
        label.textContent = row.normalizedTechnicalFact.label;
        value.textContent = row.normalizedTechnicalFact.value;
      } else {
        appendClonedChildren(row.label, label);
      }
      if (!row.normalizedTechnicalFact && row.valueSource !== 'description') {
        value.textContent = row.structuredValue;
      } else if (!row.normalizedTechnicalFact) {
        appendClonedChildren(row.value, value);
      }

      if (row.factKey) {
        item.dataset.spiritProfileFactKey = factDataKey(row.factKey);
        item.dataset.spiritProfileFactSource = row.valueSource;
      }

      if (
        (
          row.normalizedTechnicalFact
          && (
            normalizeText(label.textContent) !== row.normalizedTechnicalFact.label
            || normalizeText(value.textContent) !== row.normalizedTechnicalFact.value
          )
        )
        || (
          !row.normalizedTechnicalFact
          && (
            semanticSnapshot(label) !== row.labelSnapshot
            || (
              row.valueSource === 'description'
              && semanticSnapshot(value) !== row.valueSnapshot
            )
          )
        )
      ) {
        return null;
      }

      const iconType = resolveFactIconType(label.textContent);
      if (iconType === 'ean') {
        item.dataset.spiritProfileEan = 'source';
      }

      item.append(
        createIcon(documentRef, iconType, iconAssets),
        label,
        value,
      );
      list.appendChild(item);
    }

    if (barcode.mode === 'supplemental' && barcode.value !== '') {
      list.appendChild(createSupplementalEanItem(
        documentRef,
        ui.ean,
        barcode.value,
        iconAssets,
      ));
    }

    body.appendChild(list);
    return card;
  };

  const buildStatusBar = (documentRef, statusSummary, iconAssets, ui) => {
    if (!statusSummary) {
      return null;
    }

    const labels = {
      volume: ui.volume,
      alcohol: ui.alcohol,
      chillFiltered: ui.chillFiltered,
      colorants: ui.colorants,
    };
    const icons = {
      volume: 'volume',
      alcohol: 'strength',
      chillFiltered: 'non-chill-filtered',
      colorants: 'natural-color',
    };
    const fragment = documentRef.createDocumentFragment();

    for (const itemData of statusSummary.items) {
      const item = documentRef.createElement('div');
      item.className = `spirit-profile-status-bar__item spirit-profile-status-bar__item--${icons[itemData.key]}`;
      item.dataset.spiritProfileStatusItem = itemData.key;

      const label = documentRef.createElement('dt');
      label.className = 'spirit-profile-status-bar__label';
      const labelText = documentRef.createElement('span');
      labelText.className = 'spirit-profile-status-bar__label-text';
      labelText.textContent = labels[itemData.key];
      label.append(
        createIcon(documentRef, icons[itemData.key], iconAssets),
        labelText,
      );

      const value = documentRef.createElement('dd');
      value.className = 'spirit-profile-status-bar__value';
      value.textContent = itemData.value;

      item.append(label, value);
      fragment.appendChild(item);
    }

    return fragment;
  };

  const buildCards = (page, source, analysis, ui, barcode) => {
    const documentRef = source.ownerDocument;
    const fragment = documentRef.createDocumentFragment();
    const iconAssets = resolveIconAssets(page);
    const intro = analysis.statusSummary
      ? analysis.intro.filter((node) => node !== analysis.statusSummary.node)
      : analysis.intro;
    const cards = [
      buildNarrativeCard(
        documentRef,
        'about',
        analysis.groups.about.heading.text,
        [...intro, ...analysis.groups.about.nodes],
      ),
      buildTastingCard(
        documentRef,
        analysis.groups.tasting.heading.text,
        analysis.tastingRows,
        iconAssets,
      ),
      buildNarrativeCard(
        documentRef,
        'distillery',
        analysis.groups.distillery.heading.text,
        analysis.groups.distillery.nodes,
      ),
      buildFactsCard(
        documentRef,
        analysis.groups.facts.heading.text,
        analysis.factRows,
        iconAssets,
        barcode,
        ui,
      ),
    ];

    if (cards.some((card) => card === null)) {
      return null;
    }

    cards.forEach((card) => fragment.appendChild(card));
    return {
      cards: fragment,
      statusBar: buildStatusBar(
        documentRef,
        analysis.statusSummary,
        iconAssets,
        ui,
      ),
      iconAssets,
    };
  };

  /*
   * The status container is server-rendered in the `pending` state with
   * placeholder rows that reserve its final height. `ready` reveals the
   * validated rows, `skipped` collapses the container entirely. The legacy
   * `hidden` attribute is cleared so the state attribute stays authoritative.
   */
  const setStatusState = (statusContainer, state) => {
    if (!statusContainer) {
      return;
    }
    statusContainer.dataset.spiritProfileStatusState = state;
    statusContainer.hidden = false;
  };

  const setFallback = (wrapper, reason) => {
    wrapper.dataset.spiritDescriptionState = 'fallback';
    wrapper.dataset.spiritDescriptionReason = reason;
    delete wrapper.dataset.spiritDescriptionWarnings;
    delete wrapper.dataset.spiritDescriptionWarningCount;
  };

  const setWarnings = (wrapper, warnings) => {
    const uniqueWarnings = Array.from(new Set(warnings || [])).sort();
    if (uniqueWarnings.length === 0) {
      delete wrapper.dataset.spiritDescriptionWarnings;
      delete wrapper.dataset.spiritDescriptionWarningCount;
      return;
    }

    wrapper.dataset.spiritDescriptionWarnings = uniqueWarnings.join(' ');
    wrapper.dataset.spiritDescriptionWarningCount = String(uniqueWarnings.length);
  };

  const setupAsidePlacement = (page) => {
    const aside = page.querySelector(ASIDE_SELECTOR);
    const factsCard = page.querySelector('[data-spirit-description-card="facts"]');
    const whiskybaseCard = page.querySelector('[data-spirit-whiskybase-card]');
    const whiskybaseMount = whiskybaseCard?.closest(WHISKYBASE_MOUNT_SELECTOR) || null;
    const whiskybaseMobileSlot = page.querySelector(WHISKYBASE_MOBILE_SLOT_SELECTOR);
    if (
      !aside
      || (!factsCard && !whiskybaseMount)
      || typeof window.matchMedia !== 'function'
    ) {
      return;
    }

    const mediaQuery = window.matchMedia(DESKTOP_QUERY);
    const factsPlaceholder = factsCard
      ? page.ownerDocument.createComment('spirit facts original position')
      : null;
    const whiskybasePlaceholder = whiskybaseMount
      ? page.ownerDocument.createComment('spirit whiskybase original position')
      : null;

    if (factsCard && factsPlaceholder) {
      factsCard.parentNode.insertBefore(factsPlaceholder, factsCard);
    }
    if (whiskybaseMount && whiskybasePlaceholder) {
      whiskybaseMount.parentNode.insertBefore(whiskybasePlaceholder, whiskybaseMount);
    }

    const synchronize = () => {
      if (mediaQuery.matches) {
        if (whiskybaseMount) {
          aside.appendChild(whiskybaseMount);
        }
        if (factsCard) {
          aside.appendChild(factsCard);
        }
        aside.hidden = false;
        page.classList.add('main-product--spirit-description-aside');
        return;
      }

      if (whiskybaseMount) {
        if (whiskybaseMobileSlot) {
          whiskybaseMobileSlot.appendChild(whiskybaseMount);
        } else if (whiskybasePlaceholder?.parentNode) {
          whiskybasePlaceholder.parentNode.insertBefore(
            whiskybaseMount,
            whiskybasePlaceholder,
          );
        }
      }
      if (factsCard && factsPlaceholder?.parentNode) {
        factsPlaceholder.parentNode.insertBefore(factsCard, factsPlaceholder);
      }
      aside.hidden = true;
      page.classList.remove('main-product--spirit-description-aside');
    };

    if (typeof mediaQuery.addEventListener === 'function') {
      mediaQuery.addEventListener('change', synchronize);
    } else if (typeof mediaQuery.addListener === 'function') {
      mediaQuery.addListener(synchronize);
    }

    synchronize();
  };

  const setBarcodeFallbackHidden = (page, hidden) => {
    const fallback = page.querySelector(BARCODE_FALLBACK_SELECTOR);
    if (fallback) {
      fallback.hidden = hidden;
    }
  };

  const synchronizeBarcode = (page, barcode, ui, iconAssets) => {
    const currentValue = readBarcodeValue(page);

    if (barcode.mode === 'source') {
      setBarcodeFallbackHidden(
        page,
        currentValue !== '' && currentValue === barcode.value,
      );
      return;
    }

    const list = page.querySelector(
      '[data-spirit-description-card="facts"] .spirit-fact-list',
    );
    if (!list) {
      return;
    }

    let row = list.querySelector('[data-spirit-profile-ean="supplemental"]');
    if (currentValue === '') {
      if (row) {
        row.remove();
      }
      setBarcodeFallbackHidden(page, false);
      return;
    }

    if (!row) {
      row = createSupplementalEanItem(
        page.ownerDocument,
        ui.ean,
        currentValue,
        iconAssets,
      );
      list.appendChild(row);
    } else {
      row.querySelector('.spirit-fact-list__value').textContent = currentValue;
    }

    setBarcodeFallbackHidden(page, true);
  };

  const setupBarcodeSynchronization = (page, barcode, ui, iconAssets) => {
    synchronizeBarcode(page, barcode, ui, iconAssets);

    const variants = page.querySelector('[data-main-product-variants]');
    if (!variants || variants.dataset.spiritProfileBarcodeBound === 'true') {
      return;
    }

    variants.dataset.spiritProfileBarcodeBound = 'true';
    variants.addEventListener('VARIANT_CHANGE', () => {
      synchronizeBarcode(page, barcode, ui, iconAssets);
    });
  };

  const enhanceDescription = (page) => {
    const wrapper = page.querySelector(DESCRIPTION_SELECTOR);
    if (!wrapper || wrapper.dataset.spiritDescriptionState === 'enhanced') {
      return;
    }

    const source = wrapper.querySelector(SOURCE_SELECTOR);
    const cards = wrapper.querySelector(CARDS_SELECTOR);
    const statusContainer = page.querySelector(STATUS_CONTAINER_SELECTOR);
    const statusBar = page.querySelector(STATUS_BAR_SELECTOR);

    // Every path that does not produce a validated status bar has to collapse
    // its server-rendered height reservation, otherwise the placeholder rows
    // would leave an empty gap above the description.
    const abort = (reason) => {
      setFallback(wrapper, reason);
      setStatusState(statusContainer, 'skipped');
    };

    if (!source || !cards || !statusContainer || !statusBar) {
      abort('missing_dom_contract');
      return;
    }

    const ui = resolveUiContract(page);
    if (!ui) {
      abort('missing_ui_contract');
      return;
    }

    const productContract = resolveProductContract(page);
    if (!productContract) {
      abort('missing_product_contract');
      return;
    }

    const analysis = analyzeDescription(
      source,
      resolveLocale(page),
      ui,
      productContract,
    );
    if (!analysis.ok) {
      abort(analysis.reason);
      return;
    }

    const barcode = analyzeBarcode(page, analysis.factRows);
    if (!barcode.ok) {
      abort(barcode.reason);
      return;
    }

    const enhancement = buildCards(page, source, analysis, ui, barcode);
    if (
      !enhancement
      || enhancement.cards.childElementCount !== REQUIRED_SECTION_ORDER.length
      || (
        analysis.statusSummary
        && (
          !enhancement.statusBar
          || enhancement.statusBar.childElementCount !== analysis.statusSummary.items.length
        )
      )
    ) {
      abort('semantic_coverage_failed');
      return;
    }

    cards.replaceChildren(enhancement.cards);
    if (enhancement.statusBar) {
      statusBar.replaceChildren(enhancement.statusBar);
      setStatusState(statusContainer, 'ready');
    } else {
      statusBar.replaceChildren();
      setStatusState(statusContainer, 'skipped');
    }
    source.remove();
    cards.hidden = false;
    wrapper.dataset.spiritDescriptionState = 'enhanced';
    delete wrapper.dataset.spiritDescriptionReason;
    setWarnings(wrapper, analysis.warnings);
    setupBarcodeSynchronization(
      page,
      barcode,
      ui,
      enhancement.iconAssets,
    );
  };

  const collectPages = (root) => {
    const pages = [];
    if (root && root.nodeType === 1 && root.matches(PAGE_SELECTOR)) {
      pages.push(root);
    }
    if (root && typeof root.querySelectorAll === 'function') {
      pages.push(...root.querySelectorAll(PAGE_SELECTOR));
    }
    return pages;
  };

  const initialize = (root = document) => {
    collectPages(root).forEach((page) => {
      if (page.dataset.spiritProfileInitialized === 'true') {
        return;
      }
      page.dataset.spiritProfileInitialized = 'true';
      try {
        enhanceWhiskybase(page);
        enhanceDescription(page);
        setupAsidePlacement(page);
      } catch (error) {
        // An unexpected failure must never leave the reserved placeholder
        // height behind as an empty gap. The raw description stays visible.
        setStatusState(
          page.querySelector(STATUS_CONTAINER_SELECTOR),
          'skipped',
        );
        throw error;
      }
    });
  };

  initialize();

  document.addEventListener('shopify:section:load', (event) => {
    initialize(event.target);
  });
})();
